import http from './http';
import Product from './models/Product';
import Promotion from './models/Promotion';
import Offering from './models/Offering';

export class ProductsAPI {
	static PRODUCTS_BY_PRODUCT_GROUP_CODE_ENDPOINT = 'item/GetByProductGroupCode';
	static PROMOTIONS_ENDPOINT = 'promotion/getPromotions';
	static OFFERINGS_ENDPOINT = 'item/GetByCategoryId';
	static DOWNLOAD_PROMOTION_PDF = 'print/GeneratePromotionPdf';
	static DOWNLOAD_PROMOTION_EXCEL = 'print/GeneratePromotionExcel';

	fetchByProductGroup(group_code) {
		let endpoint = ProductsAPI.PRODUCTS_BY_PRODUCT_GROUP_CODE_ENDPOINT;
		endpoint += `?productGroupCode=${group_code}`;

		return http
			.get(endpoint)
			.then(products => products.map(product => new Product(product)));
	}

	fetchPromotions() {
		return http
			.get(ProductsAPI.PROMOTIONS_ENDPOINT)
			.then(promos => promos.map(promo => new Promotion(promo)));
	}

	fetchOfferings(categoryId, promotionId) {
		let endpoint = ProductsAPI.OFFERINGS_ENDPOINT;
		endpoint += `?categoryId=${categoryId}&promotionId=${promotionId}`;

		return http
			.get(endpoint)
			.then(offerings => offerings.map(offering => new Offering(offering)));
	}

	fetchDownloadPromotion(promotionId, isPdf, categoryId) {
		const endpoint = isPdf
			? `${ProductsAPI.DOWNLOAD_PROMOTION_PDF}?promotionId=${promotionId}&&categoryId=${categoryId}`
			: `${ProductsAPI.DOWNLOAD_PROMOTION_EXCEL}?promotionId=${promotionId}&&categoryId=${categoryId}`;
		return http.post(endpoint).then(response => response);
	}
}

export default new ProductsAPI();



// WEBPACK FOOTER //
// ./src/api/products.js